/** Plain-text views of composer HTML (guard inputs, fingerprints). Owner: web-case-composer (slice 16). */

export const textOf = (html: string) =>
  html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;|&apos;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/\n{3,}/g, '\n\n')
    .trim()

const GREETING = /^\s*(?:hi|hello|hey|dear|good (?:morning|afternoon|evening))\s+([A-Za-z][\w'-]*)/i

/** The first name the body greets ("Hi Dana," -> "Dana"), if any. */
export function greetingOf(html: string): string | undefined {
  return textOf(html).match(GREETING)?.[1]
}
